import { createIcon } from './createIcon'

export const AlignmentIcon = createIcon({
  displayName: 'AlignmentIcon',
  viewBox: '4 6 12 8',
  path: [
    <path
      d="M4 14V12.6667H8V14H4ZM4 10.6667V9.33333H12V10.6667H4ZM4 7.33333V6H16V7.33333H4Z"
      fill="currentColor"
    />,
  ],
})
